<template>
  <div class="full-height tkRefundApply linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      {{ $t('B020', '申请退票') }}
    </ld-header>
    <!--  -->
    <div class="tkRefundApplywrapper">
      <mescroll-vue
        :down="down"
      >
        <div class="content">
          <!--航段展示-->
          <div
            class="m-b-5"
            v-for="(info,index3) in tkOrderRangeBeanList"
            :key="index3"
          >
            <voyage
              :show-check="true"
              :show-cabin="true"
              :flights="[info]"
              @selected="voyageChange.call(this, index3)"
            >
              <template
                v-if="info.changeMap"
                #tag
              >
                <van-tag
                  size="medium"
                  color="#8b8ba6"
                >
                  <span>原行程</span>
                </van-tag>
                &nbsp;
              </template>
              <template
                #bottom
                v-if="info.changeMap"
              >
                <new-voyage
                  :flight="changeData(info.changeMap)"
                  :show-car="true"
                  :show-cabin="true"
                >
                  <template #tag>
                    <van-tag
                      class="bg-main white"
                      size="medium"
                    >
                      <span>新行程</span>
                    </van-tag>
                    &nbsp;
                  </template>
                  <template #bottom>
                    <van-row
                      class="noExitTip m-b-5 orange bg-lightColor"
                      gutter="8"
                    >
                      <van-col span="1">
                        <van-icon name="warning" />
                      </van-col>
                      <van-col span="21">
                        原行程发生过改签，按新行程进行退票！
                      </van-col>
                    </van-row>
                  </template>
                </new-voyage>
              </template>
            </voyage>
          </div>
          <!-- 乘机人 -->
          <van-cell
            class="m-b-5"
            v-for="(passItem,index1) in tkOrderPsgBeanList"
            :key="index1"
          >
            <template slot="title">
              {{ passItem.psgName }}
              <van-tag
                type="warning"
                v-show="passItem.fsEmpId"
              >
                {{ $t('attach', '附') }}
              </van-tag>
            </template>
            <template slot="default">
              <van-checkbox
                v-show="passItem.isShow"
                class="fr"
                v-model="passItem.checked"
                :disabled="passItem.disabled"
                @change="choosePsg(index1)"
              />
            </template>
            <template slot="label">
              <div style="width: 272px;">
                {{ DocumentType[passItem.idType] }}：{{ passItem.idNo }}
              </div>
              <div>{{ $t('F008', '手机号') }}：{{ passItem.phoneNumber }}</div>
              <div>{{ $t('F005', '票号') }}：{{ passItem.tkno }}</div>
            </template>
          </van-cell>

          <RefundReason
            v-if="tkOrderPsgBeanList.length >0 && tkOrderRangeBeanList.length > 0"
            :fileList="fileList"
            :orderId="orderId"
            orderPamsCode="11601037"
            orderPamsCodeNo="11601039"
            @fileList="fileList = $event"
            @takein="cancelReasonnew"
            :refundResaonNonew="refundResaonNonew"
          />
        </div>
      </mescroll-vue>
    </div>

    <!--提交申请-->
    <ld-tabbar class="bg-white">
      <van-row
        type="flex"
        align="center"
        gutter="8"
        class="full-width pad-lr-5"
        style="padding:0 8px"
      >
        <van-col span="12">
          退票费：
          <span class="font12 money-color">&yen;</span>
          <span class="font22 money-color">{{ total }}</span> 起
        </van-col>
        <van-col span="12">
          <ld-button
            main
            size="md"
            @click="toSubmitApply"
          >
            提交申请
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
    <!--  -->
    <ld-check-list
      ref="cancelReason"
      type="5"
      :title="title"
      :params="parNo"
      @selected="cancelReason"
    />
    <!-- 退票再次提醒弹窗 -->
    <Refunddialog
      :popshow="popshow"
      :refundResaon="refundResaon"
      :total="total"
      :isShowNoRefundReason="isShowNoRefundReason"
      @continueSubmit="continueSubmit()"
      @cancel="popshow=false"
    />
  </div>
</template>

<script>
import ldButton from 'Common/ldButton'
// import { Cell , Field ,Checkbox ,Tag} from 'vant'
import {
  Cell,
  CellGroup,
  Field,
  Checkbox,
  Tag,
  Popup,
  Collapse,
  CollapseItem,
  Icon,
  NoticeBar,
  Uploader,
  Toast,
  Button,
  Form,
  Dialog,
  RadioGroup,
  Radio,
} from 'vant'
import voyage from 'Components/tk/voyage/index.vue'
import newVoyage from 'Components/tk/voyage/voyage.vue'
import ldCheckList from 'Components/ldCheckList/TheReasonForTheChange/index'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldUploader from 'Components/ldUploader'
import axios from 'axios'
import {localget} from 'Utils/storage.js'
import {divisionCount} from 'Utils/tools'
import {API_DEFAULT_CONFIG} from 'Config'
import STATUSMAP from 'Utils/enum'
import  Refunddialog  from 'Views/Tk/components/refund_dialog.vue'
import { getSysParameter } from 'Utils/publicApi'
import   RefundReason   from 'Views/Tk/components/RefundReason.vue'
import { getParameter } from 'Utils/publicApi'
import travelInfo from 'Components/travelInfo'

export default {
  name: 'TkRefundApply',
  data() {
    return {
      title: '选择自愿退票原因',
      parNo: '11601037',
      tkOrderPsgBeanList: [],
      tkOrderRangeBeanList: [],
      changeMap: {},
      ids: '',
      // 申请 退票入参
      refundType: 1,
      psgIdList: [],
      rangeIdList: [],
      // 自愿退票原因
      // refundReasonVip: '',
      //  非自愿退票原因
      refundResaon: '',
      refundResaonhand:"",
      isShowReason: false,
      refundResaonNo: '',
      refundResaonNonew:{
        refundResaonNo:false,
        message:"",
      },
      //  订单类型  返回列表的参数
      findType: 1,
      // 是否显示非自愿退票原因
      isShowNoRefundReason: false,
      // 客人自愿退票（非自愿退票原因的第一条）
      middleReason: '',
      orderFrom: '',
      // showFei:false,
      total: 0,
      down: {use: false},

      // 上传附件
      fileList: [],
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      file: {},
      DocumentType: '',
      popshow:false,//是否显示弹窗
      obj:'no',
      entry:false,//
      refundApplyRemark:'',
      Reason:"请说明自愿退票原因",
      selectReason:true
    }
  },
  components: {
    ldButton,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Form.name]: Form,
    [Dialog.name]: Dialog,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    voyage,
    ldCheckList,
    ldTabbar,
    MescrollVue,
    newVoyage,
    ldUploader,
    travelInfo,
    Refunddialog,
    RefundReason,
  },
  // 计算属性   处理数据时，使用
  computed: {
    orderId() {
      return this.$route.query.orderId
    }
  },
  //页面创建时，去调用方法
  created() {
    this.getRefundOrder()
    this.getBclass()
    this.modifiedreason()
  },
  mounted() {
    this.DocumentType = STATUSMAP
  },
  activated() {
    this.getRefundOrder()
    this.getBclass()
  },
  updated() {
    console.log('this', this)
  },
  methods: {
    //获取 可改签的航段 和 乘机人
    getRefundOrder() {
      this.$api['tkOrder/applyRefund']({
        orderId: this.orderId
      }).then((resp) => {
        let cache = resp.data || {}
        this.tkOrderPsgBeanList = cache.tkOrderPsgBeanList || []
        this.tkOrderRangeBeanList = cache.tkOrderRangeBeanList || []
        this.changeMap = cache.changeMap || {}
        //这里处理当是一个人的时候默认勾选退票那个
        if(cache.tkOrderPsgBeanList.length==1){
          //判断一下这个人是否有可以退票机会
          if(this.tkOrderPsgBeanList[0].refundRangeIdList && this.tkOrderPsgBeanList[0].refundRangeIdList.length>0 && this.tkOrderPsgBeanList[0].refundRangeIdList[0]==this.tkOrderRangeBeanList[0].rangeId) {
            cache.tkOrderPsgBeanList[0].isShow=true
            cache.tkOrderPsgBeanList[0].checked=true
            cache.tkOrderPsgBeanList[0].disabled=true
          } 
          cache.tkOrderRangeBeanList.map((item)=>{
            item.checked=true
            item.disabled=true
            this.rangeIdList.push(item.rangeId)
          })
          this.matchNowFlightRule()
        }
      })
    },
    //获取第一条原因   客人自愿退票
    getBclass() {
      // this.$api['common/getBClass']({parNo: 130}).then(res => {
      this.$api['common/getBClass']({parNo: 11601039}).then(res => {
        var reasonList = res.data.list
        reasonList.forEach((item) => {
          if (item.id == 13001) {
            this.middleReason = item.cName
          }
        })
      })
    },

    //选择行程选择可退票航段    复选模式
    voyageChange(index) {
      let val = this.tkOrderRangeBeanList[index]
      if (val.checked) {
        this.rangeIdList.push(val.rangeId)
        //去匹配 可退票乘客!
        this.tkOrderPsgBeanList.length==1 ? '' : this.chooseOneRangeAndShowPass(val.rangeId, true)
      } else {
        this.tkOrderPsgBeanList.length==1 ? '' : this.chooseOneRangeAndShowPass(val.rangeId, true)
        for (var i = 0; i < this.rangeIdList.length; i++) {
          if (this.rangeIdList[i] == val['rangeId']) {
            this.rangeIdList.splice(i, 1)
          }
        }
      }
    },
    //当某一航段 被选中时，自动匹配可退票乘机人 ，供客户勾选
    chooseOneRangeAndShowPass(rangeId, boolean) {
      this.tkOrderPsgBeanList.forEach(item => {
        var rangeArr = item.refundRangeIdList || []
        rangeArr.forEach(dan => {
          if (dan == rangeId) {
            item.isShow = boolean
          }
        })
      })
      let arr = this.tkOrderPsgBeanList
      this.tkOrderPsgBeanList = []
      this.tkOrderPsgBeanList = arr
    },
    //选择非自愿退票原因
    chooseReason(parNo, title) {
      this.parNo = parNo
      this.title = title
      if (parNo === '11601039') {
        this.refundType = 2
      }
      this.$refs.cancelReason.toggle({params: parNo, title: title})
    },
    //取消原因
    cancelReason(info) {
      // if(this.parNo==11601037){
      // 	this.refundReasonVip=info.cName
      // }else{
      // this.refundResaon = info.cName
      // }
      info.cName ? this.refundResaon=info.cName : this.refundResaon=info
    },
    cancelReasonnew(info){
      if(info=='04271202'){
        this.refundResaonhand=info
      }else{
        this.refundResaon=info
        this.refundResaonhand=''
      }

    },
    // 选择可退票乘机人
    choosePsg(index) {
      let val = this.tkOrderPsgBeanList[index]
      if (val.checked) {
        if (this.psgIdList.indexOf(val.psgId) == -1) {
          this.psgIdList.push(val.psgId)
        }
      } else {
        for (var i = 0; i < this.psgIdList.length; i++) {
          if (this.psgIdList[i] == val['psgId']) {
            this.psgIdList.splice(i, 1)
          }
        }
      }
      var self = this

      if (this.psgIdList && this.psgIdList.length) {
        this.tkOrderRangeBeanList.forEach(item => {
          if (item.checked) {
            self.psgIdList.forEach(el => {
              if (self.changeMap[el + item.rangeId]) {
                item.changeMap = self.changeMap[el + item.rangeId]
              }
            })
          } else {
            item.changeMap = ''
          }
        })
        let arr = this.tkOrderPsgBeanList
        this.tkOrderPsgBeanList = []
        this.tkOrderPsgBeanList = arr
      }
    },

    // 提交申请
    toSubmitApply(obj) {
      this.obj = obj
      let rangeIdListString = this.rangeIdList.join(',')
      let psgIdListString = this.tkOrderPsgBeanList.filter(item => {
        return item.checked
      })
      psgIdListString = psgIdListString.map(item => {
        return item.psgId
      }).join(',')
      let fileArr = []
      this.fileList.forEach(o => {
        fileArr.push(o.url)
      })

      if (this.refundResaonhand == '04271202' && this.refundResaonNonew.message != '') {
        this.refundResaon = this.refundResaonNonew.message
      }

      if (rangeIdListString === '') {
        this.$toast('请选择退票航段！')
        return false
      } else if(psgIdListString === '' && this.psgIdList.length == 0) {
        if(this.checkAccept()){
          this.$toast('此行程存在售后单办理中，暂时无法再次提交售后。')
        }else{
          this.$toast('请选择乘机人！')
        }
        return false
      } else if (this.refundResaonhand == '04271202' && this.refundResaonNonew.message == '') {
        this.$toast('请输入退票原因')
        return false
      } else if ((this.refundResaon == '' && this.selectReason)) {
        this.$toast('请选择退票原因！')
        return false
      } else if (this.refundApplyRemark == '' && this.entry) {
        return this.$toast('请手动填写退票原因！')
      } else {
        // if(this.refundResaon != '') {
        // 	this.refundType = 2
        // } else {
        // 	this.refundType = 1
        // 	this.refundResaon = this.middleReason
        // }
        let queryString = {
          'orderId': this.orderId,
          'psgIdList': psgIdListString,
          'rangeIdList': rangeIdListString,
          'refundProveUrl': fileArr.join(','),
          'refundReasonVip': '-',
          'refundResaon': this.refundResaon,
          'refundType': this.refundType,
          'orderFrom': '10506',  // app
          'refundApplyRemark': this.refundApplyRemark
        }

        this.popshow = true
        if (this.obj == 'yes') {
          this.obj == 'no'
          this.$api['tkOrder/refundAdd'](queryString).then((resp) => {
            let cache = resp.data || {}
            let arr = cache.refundIdList || []
            if (arr.length > 1) {
              this.$dialog({
                confirmButtonText: '前往',
                message: '系统生成' + this.psgIdList.length + '个订单前往订单列表查看',
              }).then(() => {
                this.$router.push({
                  path: '/allOrder?findType=1',
                  query: {findType: 4}
                })
              })
            } else if (arr.length == 1) {
              this.$router.push({path: '/tk/tkRefundCmp', query: {orderId: arr[0]}})
            } else {
              this.$toast('申请失败')
            }
          })
        }
      }
    },
    checkAccept(){
      if(this.tkOrderPsgBeanList.length==1 && this.tkOrderRangeBeanList.length==1){//一个人一个航段
        if(this.tkOrderPsgBeanList[0].refundRangeIdList &&  this.tkOrderPsgBeanList[0].refundRangeIdList.length>0 && this.tkOrderPsgBeanList[0].refundRangeIdList[0]==this.tkOrderRangeBeanList[0].rangeId){
          return false
        }else{//代表没有可退的人
          return true
        }
      }else{
        return false
      }
    },
    //继续提交
    continueSubmit() {
      let obj = 'yes'
      this.popshow = false
      this.toSubmitApply(obj)
    },

    changeFei() {
      this.Reason='请说明非自愿改签原因'
      this.isShowNoRefundReason = true
      // this.showFei=true
      this.refundResaon = ''
    },
    //取消非自愿退票
    cancleNoExit() {
      this.Reason='请说明自愿改签原因'
      this.isShowNoRefundReason = false
      // this.showFei=false
      this.refundResaon = ''
    },
    matchNowFlightRule() {
      if(this.rangeIdList.length ==0){
        //请选择航
        this.$toast('请选择航段')
        return
      }
      var psgBeanList = []
      if (this.tkOrderPsgBeanList.length) {
        this.tkOrderPsgBeanList.forEach(item => {
          if (item.checked) {
            psgBeanList.push({
              psgId: item.psgId,
              rangeIds: this.rangeIdList.join(',')
            })
          }
        })
      }
      if (psgBeanList.length) {
        this.$api['tkOrder/matchNowFlightRule']({
          'orderId': this.orderId,
          'psgBeanList': psgBeanList,
          // [
          // 	{
          // 		'psgId': '',
          // 		'rangeBeanList': [
          // 			{
          // 				'rangeId': ''
          // 			}
          // 		]
          // 	}
          // ],
          'operFlag': 1//1 退票 2改签
        }).then(res => {
          var cache = res.data || []
          this.total = 0
          cache.forEach(item => {
            if (item.ruleBeanList) {
              item.ruleBeanList.forEach(el => {
                this.total += Number(el.result)
              })
            }
          })
        })
      }
    },
    changeData(item) {
      // 	newChange:false,
      // 	airlineName:item.airlineName,
      // 	departDate:item.oDepartDate,
      // 	departWeek:item.oDepartWeek,
      // 	departTime:item.oDepartTime,
      // 	arriveDate:item.oArriveDate,
      // 	arriveWeek:item.oArriveWeek,
      // 	arriveTime:item.oArriveTime,
      // 	departAirportName:item.oDepartAirportName,
      // 	arriveAirportName:item.oArriveAirportName,
      // 	departTerminal:item.oDepartTerminal,
      // 	arriveTerminal:item.oArriveTerminal,
      // 	departCityName:item.oDepartCityName,
      // 	arriveCityName:item.oArriveCityName,
      // 	flightNo:item.oFlightNo,
      // 	model:item.oModel,
      // 	cabinName:item.oCabinName,
      // 	cabin:item.oCabin,
      // 	stopFlag:item.oStopFlag,
      // 	stopCity:item.oStopCity,
      // 	stopCityName:item.oStopCityName,
      // 	stopAirport:item.oStopAirport,
      // 	stopAirportName:item.oStopAirportName,
      // 	stopArriveTime:item.oStopArriveTime,
      // 	stopDepartTime:item.oStopDepartTime,
      // },
      return {
        newChange: true,
        airlineName: item.newAirlineName,
        arriveWeek: item.narriveWeek,
        flightNo: item.newFlightNo,
        model: item.nModel,
        cabinName: item.nCabinName,
        cabin: item.nCabin,
        departAirportName: item.newDepartAirportName,
        arriveAirportName: item.newArriveAirportName,
        departCityName: item.newDepartCityName,
        arriveCityName: item.newArriveCityName,
        departDate: item.newDepartDate,
        departTime: item.newDepartTime,
        departWeek: item.newWeek,
        arriveDate: item.newArriveDate,
        arriveTime: item.newArriveTime,
        departTerminal: item.nDepartTerminal,
        arriveTerminal: item.nArriveTerminal,
        flyTime: item.nFlyTime,
        refundRule: item.nRefundRule,
        changeRule: item.nChangeRule,
        upgradeRule: item.nUpgradeRule,
        stopFlag: item.nStopFlag,
        stopCity: item.nStopCity,
        stopCityName: item.nStopCityName,
        stopAirport: item.nStopAirport,
        stopAirportName: item.nStopAirportName,
        stopArriveTime: item.nStopArriveTime,
        stopDepartTime: item.nStopDepartTime,
        shareFlightNo: item.nShareFlightNo,
      }
    },


    //自愿改签原因是否自填
    async modifiedreason() {
      //这是还要再加层判断 看是不是vip
      let res = await getSysParameter('1203')  //这里判断是，是否东美
      let userInfo = JSON.parse(localStorage.getItem('userInfo'))
      let resinfo = await this.$api['emp/vipEmpFindDetail']({//更新用户信息
        empId: userInfo.empInfo.empId
      })
      // console.log('res',res)
      if (res.value1 == "1") {
        this.selectReason = false
      } else {
        this.selectReason = true
      }
      if (res.value1 == '1' && resinfo.data.isVip != 1) {
        this.entry = true
      } else {
        this.entry = false
      }
    }
  },
  watch: {
    'rangeIdList.length'(val) {
      if (val) {
        this.matchNowFlightRule()
      }
    },
    'psgIdList.length'(val) {
      if (val) {
        this.matchNowFlightRule()
      }
    }
  }
}

</script>

<style lang="less" scoped>
.content {
  padding: 0 8px;
}

.m-b-5 {
  margin-bottom: 5px;
}

.pad-lr-5 {
  padding-left: 5px;
  padding-right: 5px;
}

.noExitTip {
  padding: 4px 8px;
  font-size: 10px;
}

.tkRefundApplywrapper {
  height: calc(100vh - 96px);
  overflow: hidden;
}

</style>
